import { Popover as Primitive } from 'radix-ui';
import { cn } from '../lib/cn';

export const Popover = Primitive.Root;
export const PopoverTrigger = Primitive.Trigger;
export const PopoverClose = Primitive.Close;
export const PopoverAnchor = Primitive.Anchor;

export interface PopoverContentProps extends Omit<
  React.ComponentProps<typeof Primitive.Content>,
  'aria-label'
> {
  /**
   * Nome acessivel do popover. Obrigatorio: o Radix da role="dialog" ao
   * conteudo, e dialogo sem nome nao e anunciado pelo leitor de tela.
   */
  label: string;
}

export function PopoverContent({
  className,
  label,
  sideOffset = 8,
  ...props
}: PopoverContentProps) {
  return (
    <Primitive.Portal>
      <Primitive.Content
        aria-label={label}
        sideOffset={sideOffset}
        className={cn(
          'z-50 rounded-wc-lg border border-subtle bg-raised p-4 text-primary shadow-wc-lg',
          className,
        )}
        {...props}
      />
    </Primitive.Portal>
  );
}
